// extracted by mini-css-extract-plugin
export var orderSummary = "_u3-0";
export var showMoreLessButton = "_u3-1";